var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCongratz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1584_1039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4744 92.5769L62.9739 60.0763L59.3673 65.9953L55.423 52.5254L40.9889 38.0913L32.8244 58.1763L28.2768 55.6757L15.6138 89.4526V89.4552L15.9825 99.7671L11.3266 100.883V100.886L1.62054 126.766C1.04049 128.313 1.50711 129.852 2.50994 130.855C3.5102 131.858 5.04409 132.33 6.59862 131.744L27.0755 124.067L27.8618 119.275L35.1652 121.033L51.0533 115.075V109.133L59.3673 111.958L74.7733 106.181L76.3922 101.572L82.8037 103.167H82.8063L94.0978 98.9344C96.7351 97.9445 97.4569 94.5594 95.4744 92.5769Z",
    fill: "url(#paint0_linear_1584_1039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8036 103.167L74.7732 106.181C66.5753 97.7122 60.6562 87.2147 57.5987 75.7659C55.6111 68.3232 54.8326 60.4759 55.4229 52.5254L62.9738 60.0763C63.0873 63.206 63.4379 66.3047 64.0179 69.3467C66.4747 82.2443 73.0202 94.1237 82.8036 103.167Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8037 103.167L74.7732 106.181C66.5753 97.7122 60.6562 87.2147 57.5988 75.7658L64.0179 69.3467C66.4747 82.2443 73.0202 94.1236 82.8037 103.167Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3672 111.958L51.0533 115.075C45.209 109.842 40.3031 103.675 36.5289 96.8357C29.6024 84.2904 26.7184 69.8259 28.2768 55.6756L34.4305 39.2668C35.4178 36.6398 38.7976 35.9 40.7878 37.8902L40.9888 38.0912C33.1938 55.6751 34.1273 75.0481 42.252 91.1125C46.3381 99.2022 52.1721 106.323 59.3672 111.958Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3672 111.958L51.0533 115.075C45.209 109.842 40.3031 103.675 36.5289 96.8359L42.252 91.1128C46.3381 99.2025 52.1721 106.323 59.3672 111.958Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1652 121.033L27.0755 124.067C24.0593 121.141 21.3112 117.942 18.8672 114.498C16.0936 110.642 13.4063 105.903 11.3267 100.886V100.883L15.6138 89.4551C17.3798 96.5136 20.3547 103.103 24.3712 108.994C27.3978 113.438 31.0198 117.483 35.1652 121.033Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1652 121.033L27.0755 124.067C24.0592 121.141 21.3111 117.942 18.8672 114.498L24.3712 108.994C27.3977 113.438 31.0198 117.483 35.1652 121.033Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1397 42.1475C59.6295 40.6373 59.6295 38.189 61.1397 36.6788C75.6877 22.1308 71.1899 7.96502 71.143 7.82349C70.4678 5.79745 71.5627 3.60746 73.5887 2.93203C75.6142 2.25634 77.8047 3.35173 78.4802 5.37776C78.7341 6.14032 84.499 24.2568 66.6083 42.1472C65.0987 43.6574 62.6498 43.6577 61.1397 42.1475Z",
    fill: "#8CD96B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2177 72.2251C92.7279 73.7353 95.1762 73.7353 96.6864 72.2251C111.234 57.6771 125.4 62.1749 125.542 62.2218C127.568 62.8969 129.758 61.8021 130.433 59.776C131.109 57.7505 130.013 55.56 127.987 54.8846C127.225 54.6307 109.108 48.8658 91.218 66.7564C89.7078 68.2664 89.7075 70.7152 91.2177 72.2251Z",
    fill: "#5AB267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.815 18.2205C125.407 21.6286 119.329 18.0091 117.202 18.914C116.297 21.0486 119.919 27.1197 116.511 30.5252C113.103 33.9333 107.026 30.3138 104.897 31.2187C103.99 33.3532 107.614 39.4218 104.206 42.8299C100.798 46.238 94.7165 42.6185 92.5923 43.5234C91.6848 45.6579 95.3095 51.7265 91.9014 55.1346C88.4237 58.6123 82.2752 54.8355 80.2567 55.841C79.2487 56.8335 77.8256 57.1635 76.5444 56.8206C75.9102 56.653 75.3095 56.3179 74.812 55.8203C73.3013 54.3096 73.3013 51.8606 74.812 50.3499C77.7638 47.3981 81.8963 47.8647 84.946 48.419C85.044 48.437 85.1419 48.455 85.2373 48.4731C85.2193 48.3777 85.2012 48.2797 85.1832 48.1818C84.6315 45.132 84.1623 40.9995 87.1167 38.0452C90.0685 35.0934 94.201 35.56 97.2507 36.1143C97.3487 36.1323 97.4466 36.1504 97.542 36.1684C97.524 36.073 97.5059 35.9751 97.4879 35.8771C96.9362 32.8273 96.467 28.6948 99.4214 25.7405C102.373 22.7887 106.506 23.2553 109.555 23.8096C109.653 23.8276 109.751 23.8457 109.847 23.8637C109.829 23.7683 109.811 23.6704 109.793 23.5724C109.241 20.5226 108.772 16.3901 111.726 13.4358C114.678 10.484 118.81 10.9506 121.86 11.5049C121.958 11.5229 122.056 11.541 122.151 11.559C122.133 11.4636 122.115 11.3657 122.097 11.2677C121.546 8.21795 121.076 4.08545 124.031 1.13109C125.539 -0.377029 127.988 -0.377029 129.499 1.13109C129.996 1.62864 130.331 2.22931 130.499 2.86607C130.842 4.14475 130.517 5.56779 129.522 6.57836C128.527 8.57861 132.26 14.7761 128.815 18.2205Z",
    fill: "url(#paint1_linear_1584_1039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9522 18.6705C96.0878 18.6705 97.8191 16.9392 97.8191 14.8035C97.8191 12.6678 96.0878 10.9365 93.9522 10.9365C91.8165 10.9365 90.0852 12.6678 90.0852 14.8035C90.0852 16.9392 91.8165 18.6705 93.9522 18.6705Z",
    fill: "#FFE470"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.296 46.0142C123.431 46.0142 125.163 44.2829 125.163 42.1472C125.163 40.0116 123.431 38.2803 121.296 38.2803C119.16 38.2803 117.429 40.0116 117.429 42.1472C117.429 44.2829 119.16 46.0142 121.296 46.0142Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.827 84.295C117.962 84.295 119.694 82.5637 119.694 80.428C119.694 78.2923 117.962 76.561 115.827 76.561C113.691 76.561 111.96 78.2923 111.96 80.428C111.96 82.5637 113.691 84.295 115.827 84.295Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.671 24.1392C57.8067 24.1392 59.538 22.4079 59.538 20.2722C59.538 18.1366 57.8067 16.4053 55.671 16.4053C53.5353 16.4053 51.804 18.1366 51.804 20.2722C51.804 22.4079 53.5353 24.1392 55.671 24.1392Z",
    fill: "#FFE470"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_1039",
    x1: 1.36731,
    y1: 85.0456,
    x2: 96.6068,
    y2: 85.0456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1584_1039",
    x1: 73.679,
    y1: 28.4759,
    x2: 130.631,
    y2: 28.4759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_1039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratz);
export default __webpack_public_path__ + "static/media/congratz.54396df39098472b8ec4d3cbff663217.svg";
export { ForwardRef as ReactComponent };